import { PublicClientApplication } from '@azure/msal-browser'
import { msalConfig } from './config'

export const msalInstance = new PublicClientApplication(msalConfig)

let initializationPromise: Promise<void> | null = null

/**
 * Initialize MSAL once and return the initialization promise.
 * Call this during application startup before using the instance.
 */
export const initializeMsal = (): Promise<void> | null => {
    if (!initializationPromise && typeof msalInstance.initialize === 'function') {
        initializationPromise = msalInstance.initialize()
    }
    return initializationPromise
}
